import React from "react";

export default class OrderCompleted extends React.Component {
  render() {
    return (
      <div className="order-completed">
        <p>
          Cảm ơn quý khách đã tin tưởng và ủng hộ Maca Vạn Phúc! Chúng tôi sẽ
          sớm giao hàng đến địa chỉ của quý khách.
        </p>
      </div>
    );
  }
}
